var _defs, _rect, _rect2, _g, _g2, _g3, _g4, _g5, _text, _text2, _text3, _text4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackendSample(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0d1b2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1b3a57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "server",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4db5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2a7fbf"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow3",
    cx: "50%",
    cy: "50%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4db5ff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4db5ff",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#bg3)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#glow3)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffffff",
    strokeOpacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 80 H600 M0 160 H600 M0 240 H600 M0 320 H600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 0 V400 M160 0 V400 M240 0 V400 M320 0 V400 M400 0 V400 M480 0 V400 M560 0 V400"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(220,110)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 160,
    height: 40,
    rx: 6,
    fill: "url(#server)",
    stroke: "#0d1b2a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 20,
    r: 4,
    fill: "#00e676"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 20,
    r: 4,
    fill: "#00e676"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 14,
    width: 90,
    height: 4,
    fill: "#0d1b2a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 22,
    width: 60,
    height: 4,
    fill: "#0d1b2a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 50,
    width: 160,
    height: 40,
    rx: 6,
    fill: "url(#server)",
    stroke: "#0d1b2a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 70,
    r: 4,
    fill: "#ffd54f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 70,
    r: 4,
    fill: "#00e676"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 64,
    width: 90,
    height: 4,
    fill: "#0d1b2a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 72,
    width: 70,
    height: 4,
    fill: "#0d1b2a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 100,
    width: 160,
    height: 40,
    rx: 6,
    fill: "url(#server)",
    stroke: "#0d1b2a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 120,
    r: 4,
    fill: "#00e676"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 120,
    r: 4,
    fill: "#00e676"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 114,
    width: 90,
    height: 4,
    fill: "#0d1b2a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 122,
    width: 50,
    height: 4,
    fill: "#0d1b2a",
    opacity: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#4db5ff",
    strokeWidth: 2,
    fill: "#4db5ff"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 180,
    x2: 220,
    y2: 180,
    strokeDasharray: "6 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 180,
    x2: 500,
    y2: 180,
    strokeDasharray: "6 4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 180,
    r: 10,
    fill: "#0d1b2a",
    stroke: "#4db5ff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510,
    cy: 180,
    r: 10,
    fill: "#0d1b2a",
    stroke: "#4db5ff",
    strokeWidth: 2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,140)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: 0,
    width: 50,
    height: 20,
    rx: 4,
    fill: "#00e676"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 14,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    fill: "#0d1b2a"
  }, "API"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(530,140)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -22,
    y: 0,
    width: 44,
    height: 20,
    rx: 4,
    fill: "#ffd54f"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 14,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    fill: "#0d1b2a"
  }, "DB"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 80,
    fontFamily: "monospace",
    fontSize: 38,
    fontWeight: 700,
    fill: "#4db5ff",
    opacity: 0.6
  }, "{ }")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 350,
    fontFamily: "monospace",
    fontSize: 38,
    fontWeight: 700,
    fill: "#4db5ff",
    opacity: 0.6
  }, "&lt;/&gt;")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 50,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 26,
    fontWeight: 800,
    fill: "#fff"
  }, "Backend Dev \u2014 Sample")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 320,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 13,
    fill: "#b0bec5"
  }, "Node.js \xB7 Microservices \xB7 REST \xB7 Docker \xB7 Redis")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackendSample);
export default __webpack_public_path__ + "static/media/backend-sample.71aeaae58ac7d4446c69753f11006833.svg";
export { ForwardRef as ReactComponent };